<template>
  <div>
    <h4>Hello, {{ displayName }}</h4>

    <EditUnit v-if="openEdit" :unitId="unitSelect" @close="closeUnit" />

    <AddNew v-if="!openEdit" @addNew="createUnit" />

    <UnitsByGroup v-if="!openEdit" :group="this.group" :key="forceUpdate" @selectUnit="openUnit" />

    <AdminGetUnits v-if="!openEdit" @loadSpecificUnits="loadSpecificUnits" />

  </div>

</template>

<script>

import EditUnit from "@/components/EditUnit";
import AddNew from "@/components/AddNew";
import UnitsByGroup from "@/components/UnitsByGroup";
import AdminGetUnits from "@/components/AdminGetUnits";

import api from "@/api";

export default {
  name: "Main",

  data: function() {
    return {
      openEdit: null,
      unitSelect: null,
      user: null,
      group: null,
      forceUpdate: 0,
    };
  },

  computed: {
    displayName() {
      return this.$store.getters.user && this.$store.getters.user.displayName;
    },
  },

  methods: {
    async createUnit(unitName) {
      let result = await api.units.create({
        unitId: "0",
        unitName: unitName,
        userId: this.$store.getters.user.userId,
        group: this.$store.getters.user.group
      });

      let { error, message, results } = result;

      if (error) {
        console.error(message);
        return;
      }

      this.openEdit = true;
      this.unitSelect = results.unit.key;
    },

    openUnit(id) {
      this.openEdit = true;
      this.unitSelect = id;
    },

    closeUnit() {
      this.openEdit = false;
      this.unitSelect = null;
    },

    loadSpecificUnits(id) {
      console.log(this.group);
      this.forceUpdate += 1;
      this.group = id;
      console.log(this.group);
    },

    validUnitName(str) {
      if (!str) return false;
      if (!str.replace(/\s/g, "").length) return false;
      return true;
    },
  },

  beforeMount() {
    this.user = this.$store.getters.user.userId;
    this.group = this.$store.getters.user.group;
  },

  components: {
    EditUnit,
    AddNew,
    UnitsByGroup,
    AdminGetUnits,
  },
};
</script>
